export const HOURS = ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00']

export const DAYS_IN_NUMBERS = [0,1,2,3,4,5,6]

export const SHORT_WEEK_DAYS = [ 'S', 'M', 'T', 'W', 'T', 'F', 'S']